import { combineReducers } from 'redux';
import loginReducer from './login/reducer';
// @ts-ignore
import storageSession from 'redux-persist/es/storage/session';
// @ts-ignore
import persistReducer from 'redux-persist/es/persistReducer';
const persistConfig = {
  key: 'login',
  storage: storageSession,
};

const rootReducer = combineReducers({
  loginReducer: persistReducer(persistConfig, loginReducer),
});

export type AppState = ReturnType<typeof rootReducer>;

export default rootReducer;
